import { Link, useLocation } from "react-router-dom";
import NavigationBar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import { useSeo } from "@/hooks/useSeo";
import { categories } from "@/mocks/categories";
import { themeOf } from "@/utils/content";

export default function NotFound() {
  const location = useLocation();

  useSeo({
    title: "页面不存在 | 511爆料",
    description: "你访问的页面不存在或已调整，可以从首页的分类导航重新选择感兴趣的内容方向。",
    canonical: location.pathname,
  });

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <NavigationBar />
      <main className="flex-1">
        <section className="relative w-full overflow-hidden bg-foreground-950 pb-16 pt-28 md:pb-20 md:pt-36">
          <div className="absolute inset-0 bg-gradient-to-br from-foreground-950 via-secondary-900 to-primary-900/80" />
          <div className="absolute -right-16 top-10 h-56 w-56 rounded-full bg-accent-500/15 blur-2xl" />

          <div className="relative z-10 mx-auto max-w-6xl px-4 md:px-8">
            <Breadcrumbs items={[{ label: "页面不存在" }]} invert />
            <p className="mt-8 font-heading text-5xl font-black leading-none text-background-50 md:text-7xl">404</p>
            <h1 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">这个页面不见了</h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100">
              路径{" "}
              <span className="rounded bg-background-50/15 px-2 py-0.5 font-mono text-xs text-background-50">
                {location.pathname}
              </span>{" "}
              没有对应的内容。不过没关系，从下面的分类导航重新选一个方向就好。
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-6xl px-4 py-12 md:px-8 md:py-16">
          <h2 className="font-heading text-lg font-bold text-foreground-950">从分类导航重新出发</h2>
          <div className="mt-5 flex flex-wrap gap-3">
            {categories.map((item) => {
              const theme = themeOf(item.slug);
              return (
                <Link
                  key={item.slug}
                  to={`/category/${item.slug}`}
                  className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium transition-colors ${theme.border} ${theme.soft} ${theme.text}`}
                >
                  <i className={item.icon} />
                  {item.name}
                  <span className="text-xs opacity-70">{item.count}</span>
                </Link>
              );
            })}
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              返回首页
            </Link>
            <Link
              to="/category/all"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              查看全部爆料
            </Link>
            <Link
              to="/faq"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              常见问题
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}